(function importProcessControllerDefinition() {
    'use strict';

    angular.module('ImportProcess')
        .controller('ImportProcessAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'importProcessService', 'authExtend', 'documentTypeService', 'containerTypeService','fileService',
    function importProcessController($scope, config, $state, $translate, errors, importProcessService, authExtend, documentTypeService, containerTypeService, fileService) {
        $scope.load = function () {

            $scope.importProcess = {
                type: 'Documents',
                typeId: null,
                associatedTypes: []
            };

            $scope.associatedType = function () {
                this.id = null;
                this.type = null;
                this.typeId = null,
                this.importProcessId = null;
                this.name = null;
                return this;
            };

            $scope.aux = {
                documentType: null,
                container: null,
                documentTypes: [],
                containerTypes: [],
                files: [],
                filesTemp: null
            };
            documentTypeService.getFunctionsTypes(['IMPORTPROCESS WRITE'])
                .then(function (result) {
                    $scope.optionsDocumentTypes = result.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                }, function (error) {
                    errors.showError(error);
                });

            containerTypeService.getFunctionsTypes(['IMPORTPROCESS WRITE']).then(function (result) {
                $scope.optionsContainerTypes = result.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });

            }, function (error) {
                errors.showError(error);
            });
        }

        $scope.getIndexFile = function (fileNew) {

            for (var i in $scope.aux.files) {
                if ($scope.aux.files.hasOwnProperty(i)) {
                    var fileOld = $scope.aux.files[i];

                    if (fileOld.name === fileNew.name) {
                        return i;
                    }
                }
            };

            return -1;
        };

        $scope.associateType = function (importProcessTypes, type) {
            if (importProcessTypes.length > 0) {
                $scope.importProcess.associatedTypes = [];
                importProcessTypes.forEach(function (ct) {
                    var associatedType = new $scope.associatedType();

                    associatedType.typeId = ct.id;
                    associatedType.type = type;
                    associatedType.name = ct.name;
                    $scope.importProcess.associatedTypes.push(associatedType);
                });
            }
        }

        $scope.addFile = function () {

            $scope.aux.filesTemp.forEach(function (file) {
                if ((/\.((xls))$/i).test(file.name) || (/\.((xlsx))$/i).test(file.name) || (/\.((csv))$/i).test(file.name)) {
                    if (file && file.size) {
                        file.fsize = fileService.FormatfileSize(file.size);
                        var index = $scope.getIndexFile(file);
                        if (~index) {
                            $scope.aux.files[index] = file;
                        } else {
                            $scope.aux.files.push(file);
                        }
                    }
                } else {
                    errors.showError('You must select an Excel file');
                    $scope.aux.filesTemp = [];
                    return;
                }
            });

            $scope.aux.filesTemp = [];
        }

        $scope.removeFile = function (file) {

            var index = $scope.getIndexFile(file);

            if (~index) {
                $scope.aux.files.splice(index, 1);
            }
        };


        $scope.cancel = function () {
            $state.go('import-process-find');
        };

        $scope.selectDocumentType = function (item) {

            var docTypeIds = [];
            $scope.optionsContainerTypesAssociation = null;
            $scope.aux.containerTypes = [];
            docTypeIds.push(item.id);

            containerTypeService.getByDocType(docTypeIds).then(function (result) {
                $scope.optionsContainerTypesAssociation = result.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            }, function (error) {
                errors.showError(error);
            });
        };

        $scope.selectContainerType = function (item) {

            $scope.optionsDocumentTypesAssociation = null;
            $scope.aux.documentTypes = [];

            documentTypeService.getByContainerId(item.id).then(function (result) {
                $scope.optionsDocumentTypesAssociation = result.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            }, function (error) {
                errors.showError(error);
            });
        };

        $scope.save = function () {

            if (!$scope.importerForm.$valid) {
                $scope.importerForm.$setSubmitted();
                errors.showError('VerifyFormData');
                return;
            }

            if ($scope.importProcess.type == 'Documents' && $scope.aux.documentType) {
                $scope.importProcess.typeId = $scope.aux.documentType.id;
                $scope.associateType($scope.aux.containerTypes, 'Containers');
            }

            if ($scope.importProcess.type == 'Containers' && $scope.aux.container) {
                $scope.importProcess.typeId = $scope.aux.container.id;
                $scope.associateType($scope.aux.documentTypes, 'Documents');
            }

            return importProcessService.create($scope.importProcess, $scope.aux.files).then(function () {
                $state.go('import-process-find');
            }, function (error) {
                errors.showError(error);
            });
        };
        $scope.load();
    }
        ]);
})();